export interface IPurchaseRequest_FLAT {
    pr_date : any
    po_date?:any
    employee_code : any
    company_code : any
    pr_number : any
    pr_description : any
    purchasing_group : any
    plant : any
    recipient : any
    registered_email1 : any
    registered_email2 : any
    billTo : any
    delivery_address_title : any
    delivery_address_name : any
    purchasing_organization : any
    delivery_address_name_1 : any
    street_or_house_number : any
    district : any
    postal_code : any
    line_item_number : any
    item_category : any
    material_code : any
    item_desc : any
    short_text : any
    matl_group : any
    quantity : any
    ordering_unit : any
    price : any
    currency : any
    delivery_date : any
    warranties : any
    po_text:any
    asset_number : any
    gl_account : any
    eval_group : any
    vendor_code : any
    vendor_name : any
    vendor_location : any
}

export enum IPOStatus {
    PUBLISHED = "PUBLISHED",
    DRAFT = "DRAFT",
    REJECTED = "REJECTED",
    APPROVED = "APPROVED",
    PO_CREATED = "PO_CREATED",
    PO_CONFIRM = "PO_CONFIRM",
    MRP = "MRP",
    MRP_WITH_VENDOR = "MRP PR WITH VENDOR",
    MRP_WITHOUT_VENDOR ="MRP PR WITH OUT VENDOR",
    BUYER_ENQUIRY = 'BUYER_ENQUIRY',
    FACTORY_APPROVAL = 'SENT FOR FACTORY PROCUREMENT APPROVAL',
    QES_APPROVAL = 'SENT FOR QES APPROVAL',
    PR_SUBMITTED = 'SUBMITTED FOR REVIEW'
}

export interface IPurchaseRequest {
    billTo: string
    company_code: string
    employee_code: any
    address : IAddress,
    line_items : Array<any>
    plant: string
    prId : any;
    pr_date: string
    po_date?:string
    pr_number: number
    pr_description : string
    quotations:any;
    // prId_id?:any
    division: string
    purchasing_group: string
    purchasing_organization: string
    recipient: string
    registered_email1: string
    registered_email2: string
    secondary_buyer_id ?: any;
    primary_buyer_id ?: any;
    status: IPOStatus | null | string | ""

    created_by ?: any;
    total_cost ?: any
    modified_by ?: any
    modified_date ?: any
    forwared_by ?: any
    total_effective_cost ?: any
    created_date ?: any;
    remarks ?: string | null;

    user_domain ?: string;
    acc_assignment_value ?: string;
    acc_assignment_category ?: string;
    total_finalPrice?: any;
    po_number?: any;
    is_vendor_code_present?: any;
    isMRPpr?:boolean;
    isAffiliated?: boolean;
}

export interface ILineItemDetail {
    index ?: number;
    material_master :  IMaterialMaster | null,
    account_details :  IAccountDetail | null,
    vendor_details :  IVendorDetail | null,
    line_item_number?: string 
    line_items?: any;
    // prId:any;
}

export interface IMaterialMaster {
    material_master_id ?:number
    line_item_number?: any,
    item_category: string,
    material_code: any,
    item_desc: string,
    short_text: string,
    matl_group: string,
    quantity: any,
    ordering_unit: string,
    price: any,
    currency: string,
    delivery_date: string|null,
    warranties: string,
    po_text:any,
    service_category?:string|'',
    with_material?:any,
    hsn_sac?:any;
    secondary_buyer_id ?: any
    forwared_by ?: any;
    forwarded_by ?: any,
    forwarded_by_email ?: any,
    item_no_of_purchase_requisition ?: any,
    line_item_remarks ?: any
    line_item_status ?: any
    prId?: any,
    buyer_rate_contract_id: any,
    primary_buyer_id: any;
    esn ?: any
    rcid ?: any
    uom ?: any;
    pr_number?: any;
}

export interface IAccountDetail {
    asset_number?: any,
    account_details_id ?: number
    gl_account: any,
    eval_group: string,
    acc_assignment_category: any,
    acc_assignment_value: any,
    sales_order_no: any,
    material_master_id ?: any,
}

export interface IVendorDetail {
    vendor_code: string,
    vendor_name: string,
    vendor_details_id ?: number
    vendor_location: string
    account_details_id ?: any
}

export interface IAddress {
    address_id ?: number;
    delivery_address_title: string,
    delivery_address_name:  string ,
    delivery_address_name_1: string,
    street_or_house_number: string,
    district: string,
    postal_code: any
    prId ?: number
    city : string,
    country : string,
    region : string
}

